import FeedbackPage from '@/components/FeedbackPage'

export default function ObstaclesFeedbackPage() {
  return (
    <FeedbackPage emoji="🎉" title="pages.onboarding.obstaclesFeedback.title" />
  )
}
